import "./About.css";

export const About = () => {
  return (
    <div className="about-container">
      <h1>About</h1>
      <p>
        Established in 2006, Audio Reunited is a small company based in Epsom,
        Surrey run by Jonathan Harris Cowley.
        <br />
        <br /> I have 30 years experience as a professional sound engineer and I
        spent 7 years at the Royal Festival Hall on London’s South Bank where I
        ran the Audio Archive department. This involved recording and editing a
        significant and varied amount of material covering almost every genre,
        from solo folk acts to the London Philharmonic Orchestra. I also
        transferred some of the South Bank’s archive material, dating back to
        the 1950s, onto DAT and CD.
        <br />
        <br /> Over the years the experience I have gained means that I have a
        broad and in-depth appreciation of how music should sound. In a lot of
        cases knowing what should not be done to a recording is as important as
        knowing what can be done. In this way I know that I can maintain the
        original feel of a recording while removing as much of the unwanted
        noise as is practical. The business came about from a collection of 78s
        that I wanted to have on CD. After a significant amount of investigation
        I arrived at a setup using classic, high quality playback equipment and
        state of the art computer software to provide re-mastered copies of your
        recorded material.
      </p>
    </div>
  );
};
